import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermsValue } from '../../../packages/JsonQuery';
import { LEGACY_TO_UI_BUILDING_TYPE } from '../../../packages/JsonQuery/utils/mapBuildingType';
import { EBuildingType } from '../../../packages/JsonQuery/types/buildingType';
import { EBuildingTypeLegacy } from '../../../packages/api-models/common/json_query';

export const selectBuildingType = createSelector(selectJsonQuery, jsonQuery => {
  const building = (getTermsValue('building_type__building')(jsonQuery) ?? []) as EBuildingTypeLegacy[];
  const generic = (getTermsValue('building_type2')(jsonQuery) ?? []) as EBuildingTypeLegacy[];
  const merged = new Set<EBuildingType>();

  for (const value of [...building, ...generic]) {
    const ui = LEGACY_TO_UI_BUILDING_TYPE[value];
    if (ui !== undefined) {
      merged.add(ui);
    }
  }

  return merged.size > 0 ? Array.from(merged) : null;
});
